"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4470],{

/***/ 84649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/features/base-ui/Image.js
var Image = __webpack_require__(94477);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js + 1 modules
var emotion_element_f0de968e_browser_esm = __webpack_require__(20442);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./src/features/base-ui/index.js + 31 modules
var base_ui = __webpack_require__(82843);
// EXTERNAL MODULE: ./node_modules/react-icons/gi/index.esm.js
var index_esm = __webpack_require__(2585);
// EXTERNAL MODULE: ./src/hooks/dataProvider/index.js + 1 modules
var dataProvider = __webpack_require__(46766);
// EXTERNAL MODULE: ./src/features/webpage/Head.js
var Head = __webpack_require__(56857);
// EXTERNAL MODULE: ./src/features/webpage/Nav.jsx
var Nav = __webpack_require__(32238);
// EXTERNAL MODULE: ./src/features/page-builder/SearchModal.js
var SearchModal = __webpack_require__(84015);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./src/features/ads/ad_selection.js + 2 modules
var ad_selection = __webpack_require__(12547);
;// CONCATENATED MODULE: ./src/features/webpage/WebsiteHeader.js
/* eslint-disable react/jsx-no-target-blank */ 












function ThemeHeader() {
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var data = (0,dataProvider/* useDataProvider */.x5)().data;
    var ref = (0,react.useState)(false), mobileMenuVisible = ref[0], setMobileMenuVisible = ref[1];
    var headerColor = theme.colors.websiteHeader.color;
    (0,react.useEffect)(function() {
        if (!window) return;
        var lastScrollTop = 0, delta = 15;
        var onScroll = function onScroll() {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (Math.abs(lastScrollTop - st) <= delta) return;
            if (st > lastScrollTop && lastScrollTop > 0) {
                // downscroll code
                document.querySelector("header").style.top = "-86px";
            } else {
                // upscroll code
                document.querySelector("header").style.top = "0px";
            }
            lastScrollTop = st;
        };
        window.addEventListener("scroll", onScroll);
        // Clean up the event listener to prevent memory leaks
        return function() {
            window.removeEventListener("scroll", onScroll);
        };
    }, []);
    var ref1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* default */.Z, (0,_object_spread/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.head)),
            (data === null || data === void 0 ? void 0 : data.showHeader) !== false && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Nav/* default */.Z, {
                        items: data === null || data === void 0 ? void 0 : data.menuItems,
                        visible: mobileMenuVisible,
                        onClose: function() {
                            return setMobileMenuVisible(false);
                        },
                        type: "mobile"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("header", {
                        className: theme.components.websiteHeader.className,
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(theme.components.websiteHeader.style, "                            transition:0.3s ease;@media (max-width:1024px){height:86px;}"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            id: "nav-wrapper",
                            className: "w-full",
                            style: {
                                gap: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                    id: "logo",
                                    href: "/",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        id: "logo-wrapper",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                                            noStyle: true,
                                            layout: "fill",
                                            objectFit: "contain",
                                            alt: "logo",
                                            src: "/img/project/logo.png"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Nav/* default */.Z, {
                                    items: data === null || data === void 0 ? void 0 : data.menuItems
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ad_selection/* default */.ZP, {
                                    ads: (ref1 = data === null || data === void 0 ? void 0 : data.siteAds) !== null && ref1 !== void 0 ? ref1 : [],
                                    location: "site_header_menu",
                                    style: {
                                        maxHeight: 60,
                                        objectFit: "contain"
                                    },
                                    Wrapper: function(param) {
                                        var children = param.children;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            style: {
                                                display: "inline-flex",
                                                gap: 5,
                                                alignItems: "center",
                                                maxHeight: "100%",
                                                overflow: "hidden",
                                                flex: 1,
                                                justifyContent: "flex-end"
                                            },
                                            children: children
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "flex mr-auto",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchModal/* default */.Z, {
                                            trigger: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                                id: "quik-search-btn",
                                                type: "button",
                                                className: "site-button-link",
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("svg{font-size:24px;color:", theme.colors.primary, ";font-weight:100;margin:0 1rem;}"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_index_esm/* AiOutlineSearch */.RB5, {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                            className: "flex-item lg:hidden",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", headerColor, ";border-right:1px solid\n                                            ", theme.colors.lightGray, ";padding:0 1rem;"),
                                            onClick: function() {
                                                setMobileMenuVisible(true);
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* GiHamburgerMenu */.vHB, {
                                                className: "text-3xl"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var WebsiteHeader = (ThemeHeader);

// EXTERNAL MODULE: ./src/features/webpage/WebsiteFooter.js + 1 modules
var WebsiteFooter = __webpack_require__(89248);
// EXTERNAL MODULE: ./config.json
var config = __webpack_require__(51181);
;// CONCATENATED MODULE: ./src/features/utility/SchemaMarkupLocalWebsite.jsx


function SchemaMarkupLocalWebsite() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: '{\n            "@context" : "https://schema.org",\n            "@type" : "WebSite",\n            "name" : "'.concat(config.core.website_name, '",\n            "url" : "').concat(config.core.rootUrl, '"\n}')
        }
    });
}

;// CONCATENATED MODULE: ./src/features/layouts/Layout.js







function Layout(param) {
    var children = param.children, pageProps = param.pageProps;
    var locale = (0,router.useRouter)().locale;
    (0,react.useEffect)(function() {
        if (pageProps.redirect) router_default().push(pageProps.redirect.destination);
    }, [
        pageProps === null || pageProps === void 0 ? void 0 : pageProps.redirect
    ]);
    if (pageProps.redirect) return null;
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: function(theme) {
            var ref1, ref2, ref3;
            return {
                color: (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1.text,
                fontFamily: (ref = (ref2 = theme === null || theme === void 0 ? void 0 : theme.font[locale]) === null || ref2 === void 0 ? void 0 : ref2.main) !== null && ref !== void 0 ? ref : (ref3 = theme === null || theme === void 0 ? void 0 : theme.font["default"]) === null || ref3 === void 0 ? void 0 : ref3.main,
                backgroundColor: theme.colors.mainBackground,
                direction: [
                    "ar",
                    "fa"
                ].indexOf(locale) !== -1 ? "rtl" : "ltr"
            };
        },
        className: [
            "ar",
            "fa"
        ].indexOf(locale) !== -1 ? "" : "ltr",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WebsiteHeader, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Fab */.Lg, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SchemaMarkupLocalWebsite, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WebsiteFooter/* default */.Z, {})
        ]
    });
}


/***/ }),

/***/ 63540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ SchemaMarkupNews; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _config_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51181);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12311);
/* harmony import */ var _utils_news__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98993);




function SchemaMarkupNews(param) {
    var news = param.news;
    var ref, ref1, ref2, ref3;
    var mainImage = (news === null || news === void 0 ? void 0 : (ref = news.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.hash) && "/api/filedb/".concat(news.thumbnail.file.hash, ".").concat((ref2 = news.thumbnail.file) === null || ref2 === void 0 ? void 0 : ref2.ext);
    var author = "";
    if (news.reporter) {
        author = '"author": {\n            "@type": "Person",\n            "givenName": "'.concat(news.reporter.first_name, '",\n            "familyName": "').concat(news.reporter.last_name, '",\n            "url": "').concat(_config_json__WEBPACK_IMPORTED_MODULE_0__.core.rootUrl).concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateUrl */ .nu)(news.reporter, "user"), '"\n        }');
    } else if (news.author) {
        author = '"author": {\n            "@type": "Person",\n            "name": "'.concat(news.author, '"\n        }');
    } else {
        author = '"author": {\n            "@type": "Organization",\n            "name": "'.concat(_config_json__WEBPACK_IMPORTED_MODULE_0__.core.organization, '"\n        }');
    }
    var reference = news.reference ? '"sourceOrganization":{\n        "@type":"Organization",\n        "name":"'.concat(news.reference.title, '"\n        },') : "";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("script", {
        id: "newsschema",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: '{\n            "@context": "https://schema.org",\n            "@type": "NewsArticle",\n            "mainEntityOfPage": {\n                "@type": "WebPage",\n                "@id": "'.concat(_config_json__WEBPACK_IMPORTED_MODULE_0__.core.rootUrl).concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateUrl */ .nu)(news, "news"), '"\n            },\n            "headline": "').concat(news.title.replace(/"/g, '\\"'), '",\n            ').concat(mainImage ? '"image": "'.concat(_config_json__WEBPACK_IMPORTED_MODULE_0__.core.rootUrl, "/_next/image?url=").concat(encodeURIComponent(mainImage), '&w=1200&q=75",') : "", '\n            "datePublished": "').concat((0,_utils_news__WEBPACK_IMPORTED_MODULE_2__/* .newsDisplayedPubDate */ .iu)(news, "iso"), '",\n            "dateModified": "').concat((0,_utils_news__WEBPACK_IMPORTED_MODULE_2__/* .newsDisplayedPubDate */ .iu)(news, "iso"), '",\n            ').concat(author, ",\n            ").concat(reference, '\n            "publisher": {\n                "@type": "Organization",\n                "name": "').concat(_config_json__WEBPACK_IMPORTED_MODULE_0__.core.organization, '",\n                "logo": {\n                "@type": "ImageObject",\n                "url": "').concat(_config_json__WEBPACK_IMPORTED_MODULE_0__.core.rootUrl, '/img/project/logo.png"\n                }\n            },\n            "description": "').concat((ref3 = news.abst) === null || ref3 === void 0 ? void 0 : ref3.replace(/"/g, '\\"'), '"\n        }')
        }
    });
}


/***/ }),

/***/ 51035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommentForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20442);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87536);
/* harmony import */ var _base_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82843);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74614);









function CommentForm(param) {
    var id = param.id;
    var ref, ref1, ref2;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)([
        "common",
        "validation"
    ]).t;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
    var formStyle = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("height:100%;.form-body{display:grid;align-content:center;height:100%;gap:5px;}.form-control{font-size:", theme.fontSize.sm, ";width:100%;label{display:block;margin-bottom:0.5rem;}input,select,textarea{display:block;width:100%;border-radius:", theme.borderRadius.default, ";border:1px solid ", theme.colors.lightGray, ";padding:0.375rem 0.75rem;line-height:1.5;background-clip:padding-box;&:focus{color:", theme.colors.secGray, ";background-color:", theme.colors.white, ";border-color:", theme.colors.lighter, ";outline:0;box-shadow:0 0 0 0.2rem rgb(7 176 195 / 10%);}}select{background-position:left 0.5rem center;}}");
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), success = ref3[0], setSuccess = ref3[1];
    var ref4 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useForm */ .cI)({
        mode: "onChange",
        defaultValues: {
            news_id: id
        }
    }), register = ref4.register, handleSubmit = ref4.handleSubmit, resetField = ref4.resetField, errors = ref4.formState.errors;
    function onSubmit(data) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(data) {
            var response, responseObject, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch("/api/comment", {
                                method: "POST",
                                body: JSON.stringify(data),
                                headers: {
                                    contentType: null
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        responseObject = _state.sent();
                        if (response.status === 200) {
                            setSuccess(responseObject.message);
                            resetField("content");
                        } else if (response.status === 400) {
                            setSuccess(responseObject.message);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("An unexpected error happened occurred:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _onSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("form", {
        onSubmit: handleSubmit(onSubmit),
        css: formStyle,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
            className: "form-body lg:grid-cols-2 px-4 justify-items-center",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
                    className: "form-control mt-2",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("label", {
                            children: [
                                t("نام", {
                                    ns: "common"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
                                    style: {
                                        color: "red"
                                    },
                                    children: errors === null || errors === void 0 ? void 0 : (ref = errors.username) === null || ref === void 0 ? void 0 : ref.message
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            type: "text"
                        }, register("username"))),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            type: "hidden"
                        }, register("news_id")))
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
                    className: "form-control mt-2",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("label", {
                            children: [
                                t("ایمیل", {
                                    ns: "common"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
                                    style: {
                                        color: "red"
                                    },
                                    children: errors === null || errors === void 0 ? void 0 : (ref1 = errors.contact) === null || ref1 === void 0 ? void 0 : ref1.message
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            type: "email"
                        }, register("contact")))
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
                    className: "form-control lg:col-span-2 mt-2",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("label", {
                            children: [
                                t("دیدگاه", {
                                    ns: "common"
                                }),
                                "*",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
                                    style: {
                                        color: "red"
                                    },
                                    children: errors === null || errors === void 0 ? void 0 : (ref2 = errors.content) === null || ref2 === void 0 ? void 0 : ref2.message
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("textarea", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            type: "textarea",
                            rows: "5"
                        }, register("content", {
                            required: t("دیدگاه خود را وارد کنید", {
                                ns: "validation"
                            }),
                            maxLength: 1000
                        })))
                    ]
                }),
                success === false && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                    type: "submit",
                    backgroundColor: "primary",
                    color: "lighterGray",
                    className: "mt-5 w-40 justify-center lg:col-span-2",
                    children: t("ارسال", {
                        ns: "common"
                    })
                }),
                success && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                    onClick: function(e) {
                        return e.preventDefault();
                    },
                    backgroundColor: "primary",
                    color: "lighterGray",
                    className: "mt-5 w-40 justify-center lg:col-span-2",
                    children: success
                })
            ]
        })
    });
}


/***/ }),

/***/ 92372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ NewsMetas; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12311);
/* harmony import */ var _config_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51181);
/* harmony import */ var _utils_news__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98993);





function NewsMetas(param) {
    var news = param.news, buildTime = param.buildTime;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var relativeUrl = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateUrl */ .nu)(news, "news");
    var imageUrl = (0,_utils_news__WEBPACK_IMPORTED_MODULE_3__/* .thumbnailSrc */ .xX)(news.thumbnail);
    var mainService = null;
    if (news.main_service_id) {
        mainService = news.services.find(function(s) {
            return s.id === news.main_service_id;
        });
    }
    var ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("title", {
                children: (ref9 = news === null || news === void 0 ? void 0 : news.seo_title) !== null && ref9 !== void 0 ? ref9 : news === null || news === void 0 ? void 0 : news.title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("link", {
                rel: "canonical",
                href: "".concat(_config_json__WEBPACK_IMPORTED_MODULE_2__.core.rootUrl).concat(relativeUrl)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: (ref10 = news === null || news === void 0 ? void 0 : news.seo_des) !== null && ref10 !== void 0 ? ref10 : news === null || news === void 0 ? void 0 : (ref = news.abst) === null || ref === void 0 ? void 0 : ref.slice(0, 160)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: (ref12 = (ref11 = news === null || news === void 0 ? void 0 : news.og_title) !== null && ref11 !== void 0 ? ref11 : news === null || news === void 0 ? void 0 : news.seo_title) !== null && ref12 !== void 0 ? ref12 : news === null || news === void 0 ? void 0 : news.title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: (ref15 = (ref14 = (ref13 = news === null || news === void 0 ? void 0 : news.og_des) !== null && ref13 !== void 0 ? ref13 : news === null || news === void 0 ? void 0 : news.seo_des) !== null && ref14 !== void 0 ? ref14 : news === null || news === void 0 ? void 0 : (ref1 = news.abst) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 160)) !== null && ref15 !== void 0 ? ref15 : news === null || news === void 0 ? void 0 : news.title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: "".concat(_config_json__WEBPACK_IMPORTED_MODULE_2__.core.rootUrl).concat(relativeUrl)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: "article"
            }),
            imageUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: "".concat(_config_json__WEBPACK_IMPORTED_MODULE_2__.core.rootUrl).concat(imageUrl)
            }),
            ((ref2 = news.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.alt) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                property: "og:image:alt",
                content: (ref3 = news.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.alt
            }),
            ((ref4 = news.thumbnail) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.filemeta) === null || ref5 === void 0 ? void 0 : ref5.width) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                property: "og:image:width",
                content: (ref6 = news.thumbnail) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.filemeta) === null || ref7 === void 0 ? void 0 : ref7.width
            }),
            _config_json__WEBPACK_IMPORTED_MODULE_2__.core.website_name && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                property: "og:site_name",
                content: _config_json__WEBPACK_IMPORTED_MODULE_2__.core.website_name
            }),
            news.published_at && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                property: "article:published_time",
                content: news.published_at
            }),
            news.modified_at && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                property: "article:modified_time",
                content: news.modified_at
            }),
            (mainService === null || mainService === void 0 ? void 0 : mainService.title) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                property: "article:section",
                content: mainService.title
            }),
            (ref8 = news.tags) === null || ref8 === void 0 ? void 0 : ref8.map(function(tag, idx) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                    property: "article:tag",
                    content: tag
                }, idx);
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                name: "robots",
                content: "max-image-preview:large"
            }, "previewlarge"),
            ",",
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                name: "last-update-time",
                content: buildTime
            }, "lastupdate")
        ]
    });
}


/***/ }),

/***/ 62412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageHead; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51181);



function PageHead(param) {
    var title = param.title, description = param.description, og_title = param.og_title, og_description = param.og_description, og_url = param.og_url, _og_type = param.og_type, og_type = _og_type === void 0 ? "website" : _og_type, canonical = param.canonical, og_image = param.og_image, extra = param.extra;
    if (true) {
        var ref, ref1, ref2;
        if (_config_json__WEBPACK_IMPORTED_MODULE_1__ === null || _config_json__WEBPACK_IMPORTED_MODULE_1__ === void 0 ? void 0 : (ref = _config_json__WEBPACK_IMPORTED_MODULE_1__.integrations) === null || ref === void 0 ? void 0 : (ref1 = ref.sanjagh) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.push) === null || ref2 === void 0 ? void 0 : ref2.token) window.snj_notif = {
            publisher_id: _config_json__WEBPACK_IMPORTED_MODULE_1__.integrations.sanjagh.push.token,
            delay: 5
        };
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
        children: [
            title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("title", {
                children: title
            }),
            canonical && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("link", {
                rel: "canonical",
                href: canonical
            }),
            description && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: description
            }),
            og_title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: og_title
            }, "og-title"),
            og_description && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: og_description
            }, "og-description"),
            og_url && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: og_url
            }, "og-url"),
            og_type && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: og_type
            }, "og-type"),
            og_image && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: og_image
            }, "og-image"),
            extra
        ]
    });
}


/***/ }),

/***/ 95235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ createServiceMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12311);



function traverse(current, res) {
    var maxdepth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var ref, ref1;
    var _forward_link;
    //process current node here
    res = {
        id: current.id,
        label: current.title,
        link: (_forward_link = current.forward_link) !== null && _forward_link !== void 0 ? _forward_link : (0,___WEBPACK_IMPORTED_MODULE_0__/* .generateUrl */ .nu)(current, "service")
    };
    if ((ref = current.thumbnail) === null || ref === void 0 ? void 0 : ref.hash) res.thumbnail = "/api/filedb/".concat(current.thumbnail.hash, ".").concat(current.thumbnail.ext);
    res.children = [] //.map(c => traverse(tree, c, ))
    ;
    if ((ref1 = current.children) === null || ref1 === void 0 ? void 0 : ref1.length) maxdepth += 1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        //visit children of current
        for(var _iterator = current.children.sort(function(a, b) {
            return a.position.localeCompare(b.position);
        })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var ck = _step.value;
            res.children.push(traverse(ck, void 0, maxdepth));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    res.maxDepth = maxdepth;
    return res;
}
function createServiceMenu(menuServices) {
    var ref, ref1;
    var a = menuServices.map(function(a) {
        var ref2, ref3, ref4;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, a), {
            position: [
                (ref = (ref2 = a.parent) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.padStart(3, "0")) !== null && ref !== void 0 ? ref : "",
                (ref1 = (ref4 = a.position) === null || ref4 === void 0 ? void 0 : ref4.padStart(3, "0")) !== null && ref1 !== void 0 ? ref1 : "999"
            ].join(".")
        });
    });
    return a.sort(function(a, b) {
        return a.position.localeCompare(b.position);
    }).map(function(s) {
        return traverse(s);
    });
}


/***/ })

}]);